import React from 'react';
import { useContent } from '../../hooks/useContent';
import { uploadsAbsoluteUrl } from '../../utils/uploadsBase';
import { conferenceEn } from '../../content/conferenceEn';
import styles from './ConferencePage.module.css';

const MEMBER_IDS = ['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8'];

export default function ConferencePage() {
  const { t } = useContent();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const def = conferenceEn.main;

  const heroSrc = () => {
    const path = t('conferenceMain.heroImage', def.heroImage);
    if (!path) return def.heroImage;
    const s = String(path);
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    if (s.startsWith('/uploads')) return uploadsAbsoluteUrl(s, API_URL);
    return s;
  };

  return (
    <div className={styles.page}>
      <div className={styles.banner}>
        <div className={styles.overlay} />
        <h1>{t('conferenceMain.bannerTitle', def.bannerTitle)}</h1>
      </div>

      <section className={styles.article}>
        <div className={styles.textBlock}>
          <h2>{t('conferenceMain.articleTitle', def.articleTitle)}</h2>
          <p>{t('conferenceMain.articleBody', def.articleBody)}</p>
        </div>
        <div className={styles.imageBlock}>
          <img
            src={heroSrc()}
            alt={t('conferenceMain.heroImageAlt', def.heroImageAlt)}
          />
        </div>
      </section>

      <section className={styles.committee}>
        <h2>{t('conferenceMain.committeeTitle', def.committeeTitle)}</h2>
        <div className={styles.committeeList}>
          {MEMBER_IDS.map((mid, index) => {
            const m = def.members[mid] || {};
            const name = t(`conferenceMain.members.${mid}.name`, m.name ?? '');
            const country = t(`conferenceMain.members.${mid}.country`, m.country ?? '');
            const workplace = t(`conferenceMain.members.${mid}.workplace`, m.workplace ?? '');
            return (
              <div key={mid} className={styles.memberItem}>
                <h3>{name}</h3>
                <p>
                  <strong>{t('conferenceMain.countryLabel', def.countryLabel)}</strong> {country}
                </p>
                <p>
                  <strong>{t('conferenceMain.workplaceLabel', def.workplaceLabel)}</strong>{' '}
                  {workplace}
                </p>
                {index !== MEMBER_IDS.length - 1 && <hr className={styles.divider} />}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
